import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lock-solid",
  "use": "lock-solid-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"lock-solid\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M18.4 10h-.6V7a6 6 0 00-5.9-5.9 6 6 0 00-6 5.8v3h-.3a2 2 0 00-2 2v9c0 1.1.9 2 2 2h12.7a2 2 0 002-2v-9c.1-1-.8-1.9-1.9-1.9zm-2.8 0H8V7a3.8 3.8 0 117.6 0v3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol